<div class="assinatura-modal-fundo" (click)="fecharModal()">
  <section
    class="assinatura-modal"
    role="dialog"
    aria-labelledby="titulo-assinatura"
    (click)="$event.stopPropagation()"
  >
    <header>
      <h2 id="titulo-assinatura">Assinatura do Contrato</h2>
      <button type="button" class="fechar" (click)="fecharModal()" aria-label="Fechar">
        ×
      </button>
    </header>

    <p>
      Para finalizar seu pedido, é necessário assinar o contrato comercial.
    </p>
    <p class="pedido">Pedido: #{{ consulta?.pedido_id || pedidoId }}</p>
    <p class="documento" *ngIf="consulta?.contrato?.nome_documento">
      {{ consulta.contrato.nome_documento }}
    </p>

    <p class="status">Status: {{ rotulo }}</p>
    <p class="alerta" *ngIf="mensagem">{{ mensagem }}</p>

    <iframe
      *ngIf="contratoHtml"
      [srcdoc]="contratoHtml"
      title="Contrato"
    ></iframe>

    <div class="acoes">
      <button type="button" (click)="visualizar()" [disabled]="carregando">
        Visualizar Contrato
      </button>
      <button type="button" (click)="assinar()" [disabled]="carregando">
        Assinar Contrato
      </button>
      <button type="button" (click)="verificar()" [disabled]="carregando">
        Verificar Assinatura
      </button>
      <button
        type="button"
        *ngIf="consulta?.contrato?.url_documento_assinado"
        (click)="baixar()"
      >
        Baixar contrato assinado
      </button>
    </div>

    <footer>
      <button type="button" class="voltar" (click)="fecharModal()">Voltar</button>
      <button
        type="button"
        class="confirmar"
        [disabled]="!podeFinalizar"
        (click)="finalizarPedido()"
      >
        Finalizar Pedido
      </button>
    </footer>
  </section>
</div>
